mutation ConnectStripe($input: ConnectStripeInput!) {
  connectStripe(input: $input) {
    id
    paymentSettings {
      publishableKey
      secretKeyMask
      connectedAt
    }
  }
}
